import { FC } from 'react'
import { MenuProps, components } from 'react-select'

import './MultiselectInput.scss'

const Menu: FC<MenuProps<any, true>> = ({ ...props }) => {
  return (
    <components.Menu {...props}>
      <div className='multiselect-input__menu-wrapper'>{props.children}</div>
    </components.Menu>
  )
}

export default Menu
